<!-- Tab Bar (Only tabs, will be placed in header) -->
<div class="tab-bar">
  @for (tab of tabs; track tab) {
    <button
      class="tab"
      [class.active]="activeTab() === tab"
      (click)="activeTab.set(tab)"
    >
      {{ tab }}
    </button>
  }
</div>

<!-- Content Area (Separate from tabs) -->
<div class="content-area">
  @switch (activeTab()) {
    @case ('Console') {
      <app-console-view [contentHeight]="childContentHeight()" />
    }
    @case ('State') {
      <app-state-view [state]="state()" [contentHeight]="childContentHeight()" />
    }
    @case ('Timeline') {
      <app-timeline-view [contentHeight]="childContentHeight()" />
    }
    @case ('Linting') {
      <div class="coming-soon-placeholder">Linting view - Coming soon</div>
    }
    @case ('Performance') {
      <div class="coming-soon-placeholder">Performance view - Coming soon</div>
    }
    @case ('Database') {
      <app-db-viewer [contentHeight]="childContentHeight()" />
    }
  }
</div>